import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

class Footer extends Component {
  render() {
    const style = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "5px"
    };

    return (
      <div className="footer-main">
        <div className="footer-body">
          <div className="footer-mission">
            <h3>Our Mission</h3>
            <p>
              To connect charities and donors, empowering them to change the
              world for the better.
            </p>
          </div>
          <div>
            <img
              className="footer-img responsive-img"
              src={"/images/landing.png"}
              alt={"Tikki"}
            />
          </div>
        </div>
        <div style={style}>
          <Link to="/privacy">Privacy</Link>
          <div style={style}>.</div>
          <Link to="/terms">Terms</Link>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js